import React from 'react'
import PropTypes from 'prop-types'
import { PrivacyTemplate } from '../../templates/privacy-template'

const PrivacyPagePreview = ({ entry }) => {
  const data = entry.getIn(['data']).toJS()
  
  if (data) {
    return (
        <PrivacyTemplate
            privacy = { data }
        />
    )
  } else {
    return <div>Loading...</div>
  }
}

PrivacyPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
}

export default PrivacyPagePreview